export default "__VITE_ASSET__Drp$SJvF__"